import { Button, Header, Modal } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

export interface DeleteConfirmationPopUpProps {
  open: boolean
  isLoading: boolean
  headerContent: string
  paragrapghContent: string
  deleteItemName?: string
  onCancel: () => void
  onConfirm: () => void
}

export const DeleteConfirmationPopup = (props: DeleteConfirmationPopUpProps) => {
  const { t } = useTranslation()

  return (
    <Modal open={props.open} size='small' data-testid='delete-modal' onClose={props.onCancel}>
      <Header content={props.headerContent} />
      <Modal.Content>
        <p data-testid='delete-paragraph'>
          {props.paragrapghContent}
          {props.deleteItemName && <b>{` ${props.deleteItemName}`}</b>}?
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button content={t('global.cancel')} icon='cancel' onClick={props.onCancel} data-testid='btn-cancel' />
        <Button
          content={t('global.confirm')}
          color='blue'
          onClick={() => props.onConfirm()}
          data-testid='btn-confirm'
          loading={props.isLoading}
        />
      </Modal.Actions>
    </Modal>
  )
}
export default DeleteConfirmationPopup
